export default "---\nurl: \"./?f=json\"\ndom_id: \"#swagger-ui\"\nvalidatorUrl: null\n";